<div class="unauthorized-container">
  <h1>Unauthorized</h1>
  <p>You do not have permission to access this page.</p>
  <a [routerLink]="'/'" class="back-link">Go to Home</a>
</div>
